<template>
  <div>
    <tabs :tabs="tabs"></tabs>
  </div>
</template>

<script>
import { Tabs } from "./Components";
import GiantScheduleTab from "./ExportGiantSchedule";
import GPARankTab from "./GPARankReport";
import TranscriptReportTab from "./TranscriptPatchReport";
import MailingLabelTab from "./MailingLabelReport";
import ClassSectionRoster from "./ClassSectionRoster";
import ReportCardBatch from "./ReportCardBatch";
import MasterRegister from "./MasterRegister";
import GraduationTracker from "./GraduationTracker";
export default {
  components: { Tabs },
  data() {
    const tabs = [
      {
        name: "giant-schedule",
        label: "extended_exportation.giant_schedule",
        component: GiantScheduleTab
      },
      {
        name: "gpa-rank",
        label: "extended_exportation.gpa_rank_report",
        component: GPARankTab
      },
      {
        name: "transcript-report",
        label: "extended_exportation.transcript_batch_report",
        component: TranscriptReportTab
      },
      {
        name: "mailing-label",
        label: "extended_exportation.mailing_label",
        component: MailingLabelTab
      },
      {
        name: "roster-report",
        label: "extended_exportation.class_section_roster",
        component: ClassSectionRoster
      },
      {
        name: "report-card-batch",
        label: "extended_exportation.report_card_batch",
        component: ReportCardBatch
      },
      {
        name: "master-register",
        label: "extended_exportation.master_register",
        component: MasterRegister
      },
      {
        name: "graduation-tracker",
        label: "extended_exportation.graduation_tracker",
        component: GraduationTracker
      }
    ];
    return {
      tabs
    };
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine";

.tab-button {
  @apply py-2 px-4;
  @apply text-gray-500 font-medium;
  @apply cursor-pointer;
  @apply outline-none;

  font-size: 1rem;

  &.active {
    border-top: 2px solid md-get-palette-color(purple, 500);
  }
}
</style>
